import type { TFunction } from 'i18next';
import type { SessionMineItem } from '@features/sessions/types/session.types';

/**
 * What to call a sitting.
 *
 * `title` is nullable in the contract and is often null in practice — nothing
 * fills it yet. A rail of rows reading "Session 3" is the shape working but the
 * screen failing, which is why backend auto-titling from the summary the worker
 * already produces is worth asking for. Until then the number is the only thing
 * every sitting is guaranteed to have.
 *
 * Note `?? ` alone will not do here: a stored empty string is not null, so it
 * would pass through as a blank row.
 */
export function sessionTitle(session: SessionMineItem, t: TFunction): string {
  const trimmed = session.title?.trim();
  return trimmed && trimmed.length > 0
    ? trimmed
    : t('assistant.untitledSession', { number: session.sequence_no });
}
